<template>
  <div id="navi-modal">
    <div class="modal">
      <div class="close" @click="close">
        <v-icon>mdi-close-circle-outline</v-icon>
        <span>닫기</span>
      </div>
      <div class="title d-flex">
        <img src="@/assets/icons/obituary/navi-icon.svg" alt="길찾기 아이콘" />
        <h4 class="ml-2">길 찾을 어플을 선택해주세요</h4>
      </div>
      <div class="address">
        <button @click="requestKakaoMap">카카오내비</button>
        <button @click="requestTmap">티맵</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    addrName: {
      type: String,
      default: String
    },
    addrX: {
      type: String,
      default: String
    },
    addrY: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      model: 0
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },

    requestTmap() {
      let tmapTxt = `https://apis.openapi.sk.com/tmap/app/routes?appKey=${process.env.VUE_APP_TMAP_APPKEY}&name=${this.addrName}&lon=${this.addrX}&lat=${this.addrY}`;

      location.href = tmapTxt;
    },

    requestKakaoMap() {
      Kakao.Navi.start({
        name: this.addrName,
        x: parseFloat(this.addrX),
        y: parseFloat(this.addrY),
        coordType: "wgs84"
      });
    }
  }
};
</script>

<style></style>
